import { Image } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

// Define the animation keyframes
const slowSpin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const FlowerImage = ({ src, top, bottom, left, right, width }) => {
  return (
    <Image
      src={src}
      position="absolute"
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      width={width} 
      zIndex={999}
      animation={`${slowSpin} 5s linear infinite`}
    />
  );
};

export default FlowerImage;
